const DEFAULT_SLOTS = {
  firstSlots: [],
  lastSlots : [],
};

const isAvailable = ({ available }) => available;

const getAvailableDates = (sourceSlots = {}) => {
  const safeSlots = sourceSlots.firstSlots && sourceSlots.lastSlots
    ? sourceSlots
    : {
      ...DEFAULT_SLOTS,
      ...sourceSlots,
    };
  const allSlots = [
    ...safeSlots.firstSlots.filter(isAvailable),
    ...safeSlots.lastSlots.filter(isAvailable),
  ];
  return allSlots.reduce((acc, {
    date, from, to, timeSlot, timezone,
  }) => {
    const currentValue = acc[date] || [];
    const newValue = [...currentValue, {
      date,
      from,
      to,
      timeSlot,
      timezone,
    }];
    return {
      ...acc,
      [date]: newValue,
    };
  }, {});
};

export default getAvailableDates;
